export const contactCTAText = {
  en: {
    title: "Ready to Start Your Journey?",
    subtitle: "Book a free consultation to discuss your goals.",
    button: "Get Started",
  },

  vi: {
    title: "Sẵn Sàng Bắt Đầu Hành Trình Của Bạn?",
    subtitle: "Đặt lịch tư vấn miễn phí để cùng trao đổi về mục tiêu của bạn.",
    button: "Bắt Đầu Ngay",
  },
};
